import React from 'react';
import PropTypes from 'prop-types';
import { ClockIcon } from '@heroicons/react/24/outline';
import './ScriptGeneratorHeader.css';

const ScriptGeneratorHeader = ({
  onBack,
  mappingCount,
  onToggleHistory,
  showHistory,
  scriptHistoryCount = 0
}) => (
  <header className="script-generator-header minimal-header">
    <nav className="sg-navbar">
      <button onClick={onBack} className="sg-back-btn" title="Back to ETL Tool">
        <span className="sg-back-arrow" aria-hidden="true">&#8592;</span>
        <span className="sg-back-text">Back to ETL Tool</span>
      </button>
      <div className="sg-title-section">
        <h1 className="sg-title">Script Generator</h1>
      </div>
      <div className="sg-actions">
        <button 
          onClick={onToggleHistory} 
          className={`sg-history-btn ${showHistory ? 'active' : ''}`}
          title="Toggle Script History"
        >
          <ClockIcon className="h-5 w-5" />
          <span className="sg-history-text">History</span>
          {scriptHistoryCount > 0 && (
            <span className="sg-history-badge">{scriptHistoryCount}</span>
          )}
        </button>
        <div className="sg-metrics">
          <span className="sg-mapping-badge">{mappingCount} Mappings</span>
        </div>
      </div>
    </nav>
  </header>
);

ScriptGeneratorHeader.propTypes = {
  onBack: PropTypes.func.isRequired,
  mappingCount: PropTypes.number.isRequired,
  onToggleHistory: PropTypes.func,
  showHistory: PropTypes.bool,
  scriptHistoryCount: PropTypes.number
};

export default ScriptGeneratorHeader; 